import { handleActions } from 'redux-actions'
import * as rawActions from '../actions'

const defaultState = null

export default handleActions(
  {
    [rawActions.setSelectedFormAnswerValue](state, { payload }) {
      return payload
    },
    [rawActions.setSelectedProject](state, action) {
      return defaultState
    },
  },
  defaultState
)
